import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Icon, Modal} from "antd"
import {updateNoteBatch} from "../../../services/api/3dApi";
import ChangeNoteModal from './ChangeNoteModal';

class BatchNote extends Component {
    constructor(props) {
        super(props)

        this.state = {
            noteNew: this.props.note || '',
            isOpen: false,
            isUpdated: false,
            error: '',
            loading: false,
            errorUpdate: ''
        }
    }

    _onOpen = () => {
        this.setState({
            isOpen: true,
            isUpdated: false
        })
    }

    _onClose = () => {
        this.setState({
            isOpen: false,
            isUpdated: false,
            error: '',
            errorUpdate: '',
            noteNew: this.props.note || ''
        })
    }

    _handleChangeNote = (value) => {
        this.setState({
            noteNew: value,
            isUpdated: true
        })
    }

    _onUpdateNewNote = async () => {
        this.setState({
            loading: true,
            errorUpdate: ''
        })

        try {
            const {batchId} = this.props
            const {noteNew} = this.state

            const {'data': response} = await updateNoteBatch(batchId, {content: noteNew})

            const {success, error} = response

            if (!success) {
                return this.setState({
                    loading: false,
                    errorUpdate: error
                })
            }

            this.setState({
                loading: false,
            }, () => {
                const {refreshBatchInfo} = this.props

                if (typeof refreshBatchInfo === 'function') {
                    refreshBatchInfo()
                }

                this.setState({
                    isOpen: false
                })

                Modal.success({
                    title: 'Thành công',
                    content: 'Thay đổi ghi chú thành công'
                })
            })
        } catch (e) {
            this.setState({
                loading: false,
                errorUpdate: e.message
            })
        }
    }

    render() {
        const {note} = this.props
        const {isOpen, noteNew, isUpdated, loading, error, errorUpdate} = this.state

        return (
            <div>
                <h6>Ghi chú:
                    <span> {note}</span>
                    <Icon type="edit" theme="twoTone" className='ml-1' onClick={this._onOpen}/>
                </h6>

                <ChangeNoteModal
                    loading={loading}
                    error={error}
                    errorUpdate={errorUpdate}
                    note={noteNew}
                    isOpen={isOpen}
                    isUpdated={isUpdated}
                    onClose={this._onClose}
                    onChangeNote={this._handleChangeNote}
                    onUpdateNote={this._onUpdateNewNote}
                />
            </div>
        )
    }
}

BatchNote.propTypes = {
    note: PropTypes.string
}

export default BatchNote
